import { InputButtonGenericContainer, InputButtonGeneric } from './styles.js';
import { jsx } from 'react/jsx-runtime';

const InputButton = _ref => {
  let {
    isDisabled,
    ...props
  } = _ref;
  return /*#__PURE__*/jsx(InputButtonGenericContainer, {
    children: /*#__PURE__*/jsx(InputButtonGeneric, {
      ...props,
      onClick: event => {
        event.stopPropagation();
        props.onClick(event);
      },
      disabled: isDisabled
    })
  });
};

export { InputButton };
//# sourceMappingURL=components.js.map
